import DarkModeSwitch from "components/DarkModeSwitch/index";

// import induzLogo from "assets/images/logos/induzLogo.svg";

import "./signUpHeader.scss";
import useTheme from "hooks/observer";

const SignUpHeader = () => {
  const theme = useTheme();
  return (
    <>
      <section className="signUpHeader">
        <div className="container signUpHeaderContainer">
          <div className="imageWrapper">
            {/* <img src={induzLogo} alt="induz" /> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="204"
              height="40"
              viewBox="0 0 204 40"
              fill="none"
            >
              {/* <path
                d="M0 10C0 4.47715 4.47715 0 10 0H194C199.523 0 204 4.47715 204 10V30C204 35.5228 199.523 40 194 40H10C4.47716 40 0 35.5228 0 30V10Z"
                fill="white"
                fillOpacity="0.01"
              /> */}
              <path
                d="M34.4754 37.9243V21.761H37.6159V37.9243H34.4754Z"
                fill={theme === "light" ? "#67308F" : "white"}
              />
              <path
                d="M40.3867 37.9243V24.8549H43.4575V26.4023C44.3811 25.1091 45.8355 24.5318 47.4061 24.5318C48.6071 24.5318 49.5532 24.786 50.3846 25.3865C51.6546 26.2179 52.3938 27.6491 52.3938 29.4041V37.9243H49.3231V29.8891C49.3231 28.3418 48.2151 27.4189 46.5522 27.4189C44.6128 27.4189 43.4583 28.527 43.4583 30.5594V37.9251H40.3875L40.3867 37.9243Z"
                fill={theme === "light" ? "#67308F" : "white"}
              />
              <path
                d="M54.2627 31.39C54.2627 27.4189 56.9646 24.5318 60.6358 24.5318C62.5296 24.5318 64.0529 25.271 65.092 26.7022V19.4519H68.1859V37.9243H65.092V36.0771C64.0529 37.509 62.5288 38.2474 60.6358 38.2474C56.9646 38.2474 54.2627 35.3611 54.2627 31.3892V31.39ZM65.092 31.39C65.092 29.1964 63.3834 27.4414 61.2131 27.4414C59.0427 27.4414 57.3342 29.1964 57.3342 31.39C57.3342 33.5836 59.0427 35.3387 61.2131 35.3387C63.3834 35.3387 65.092 33.5836 65.092 31.39Z"
                fill={theme === "light" ? "#67308F" : "white"}
              />
              <path
                d="M72.4344 37.2549C71.3032 36.4002 70.6562 35.0148 70.6562 33.376V24.8557H73.7269V32.8909C73.7269 34.4383 74.8349 35.3619 76.4977 35.3619C78.4372 35.3619 79.5917 34.2539 79.5917 32.2215V24.8557H82.6624V37.9251H79.5917V36.3777C78.6681 37.671 77.2137 38.2482 75.6431 38.2482C74.3266 38.2482 73.3108 37.9484 72.4336 37.2557L72.4344 37.2549Z"
                fill={theme === "light" ? "#67308F" : "white"}
              />
              <path
                d="M84.3718 37.9243V37.6934L89.4284 27.7878H84.8103V24.8549H94V25.0858L88.9666 34.9915H94V37.9243H84.3718Z"
                fill={theme === "light" ? "#67308F" : "white"}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26.3969 2.55164C26.2595 3.17554 25.7157 5.64476 26.8122 7.27712L26.8138 7.27632C27.9146 8.9151 29.2239 12.3586 28.6675 16.4756C28.1552 20.2735 26.8491 23.2216 24.4479 25.4641C24.431 25.0207 24.3124 24.6038 23.9115 24.2815H23.9107C24.4338 24.7641 24.2511 25.5276 24.078 26.2512C23.9775 26.671 23.8803 27.0773 23.9259 27.4076C23.976 27.7689 24.1894 28.0563 24.363 28.2901C24.6313 28.6512 24.8046 28.8845 24.1344 29.0656C23.8373 29.146 23.2942 29.4928 22.5825 29.9472C21.7193 30.4984 20.608 31.2079 19.3872 31.7923C17.1599 32.8587 12.6517 32.3383 11.8243 28.5853C11.053 25.0865 12.6565 23.9047 12.877 23.7604C12.877 23.7604 11.2261 24.5581 11.1708 27.0171C10.8622 25.8842 10.7988 24.5397 11.0738 22.9987C11.9482 18.0998 16.9962 17.3089 18.7127 17.0399L18.7474 17.0345C20.4295 16.7715 22.6135 15.8447 23.481 14.2115C24.3485 12.5783 23.8554 10.3623 23.4417 8.95118C23.028 7.5401 22.5156 5.64315 22.4162 4.46938C22.316 3.29561 22.8428 3.03584 22.8428 3.03584C22.8428 3.03584 24.1312 2.63898 25.2007 2.24131C26.2703 1.84364 26.5324 1.93263 26.3985 2.54437L26.3969 2.55164ZM19.3736 20.6871C19.3736 21.0776 19.057 21.3942 18.6664 21.3942C18.2759 21.3942 17.9593 21.0776 17.9593 20.6871C17.9593 20.2966 18.2759 19.98 18.6664 19.98C19.057 19.98 19.3736 20.2966 19.3736 20.6871Z"
                fill={theme === "light" ? "#67308F" : "white"}
              />
              <path
                d="M24.0093 29.7718C23.7119 29.8969 23.3326 30.0957 22.854 30.4092C21.192 31.4964 19.2918 33.6379 14.9912 32.5812C10.2632 30.8927 10.952 27.676 10.952 27.676C8.90107 27.8652 7.19574 28.5283 5.87204 29.2731C5.24988 28.1827 4.8931 26.9216 4.8931 25.5762C4.8931 21.4464 8.24123 18.0991 12.3703 18.0991C12.6549 18.0991 12.9347 18.1167 13.2113 18.1472C13.6635 17.7615 14.9655 16.8419 17.4349 16.4675C18.7073 16.2751 19.55 16.1075 20.1264 15.9416C18.005 14.2314 15.3071 13.2068 12.3695 13.2068C5.53852 13.2068 0 18.7445 0 25.5762C0 32.408 5.44311 37.8487 12.1931 37.9433L12.2628 37.9441C12.2989 37.9441 12.3342 37.9457 12.3703 37.9457C12.3991 37.9457 12.428 37.9441 12.4568 37.9441L24.0085 37.9224V29.7726L24.0093 29.7718Z"
                fill={theme === "light" ? "#67308F" : "white"}
              />
            </svg>
          </div>
          <div className="modeButton">
            <DarkModeSwitch />
          </div>
        </div>
      </section>
    </>
  );
};

export default SignUpHeader;
